<template>
  <modal
    ref="modal"
    cancel-title="Zrušiť"
    centered
    name="change-password"
    ok-title="Uložiť"
    scrollable
    title="Zmeniť heslo"
    @hidden="Object.assign($data, $options.data())"
    @ok="changePass"
  >
    <b-form>
      <b-form-group label="Heslo" label-for="pw1">
        <b-form-input
          ref="password"
          v-model="form.pw1"
          v-validate="'required|min:8|regex:^(?=.*[A-Za-z])(?=.*?[0-9])'"
          type="password"
          :class="{ 'is-invalid': errors.has('pw1') }"
          data-vv-as="Heslo"
          name="pw1"
        />

        <b-form-invalid-feedback>
          {{ errors.first('pw1') }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group label="Potrdenie hesla" label-for="pw2">
        <b-form-input
          v-model="form.pw2"
          v-validate="'required|confirmed:password'"
          type="password"
          :class="{ 'is-invalid': errors.has('pw2') }"
          data-vv-as="Potrdenie hesla"
          name="pw2"
        />

        <b-form-invalid-feedback>
          {{ errors.first('pw2') }}
        </b-form-invalid-feedback>
      </b-form-group>
    </b-form>
  </modal>
</template>
<script>
import Modal from '@/components/Modal'

export default {
  components: {
    Modal,
  },
  data() {
    return {
      form: {},
    }
  },
  methods: {
    changePass(e) {
      e.preventDefault()
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          this.$api
            .post(
              'users/' + this.$store.state.user.current.id + '/change_password',
              { password: this.form.pw1 },
            )
            .then((res) => {
              this.$swal({
                type: 'success',
                position: 'top',
                showCloseButton: true,
                text: res.data.success,
                timer: 5000,
              })
              this.$refs.modal.close()
            })
        } else {
          this.$swal({
            type: 'warning',
            position: 'top',
            showCloseButton: true,
            text: 'Formulár nieje správne vyplnený',
            timer: 5000,
          })
        }
      })
    },
  },
}
</script>
